import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_OUTLET_DETAILS, GET_OUTLET_DETAILS_ERROR, GET_OUTLET_DETAILS_SUCCESS } from '../../actions.js';

function* getOutletDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/digital/outlets/${payload?.id}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_OUTLET_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_OUTLET_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_OUTLET_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetOutletDetails() {
  yield takeEvery(GET_OUTLET_DETAILS, getOutletDetails);
}

function* getOutletDetailsSaga() {
  yield all([fork(watchGetOutletDetails)]);
}

export default getOutletDetailsSaga;
